export default __webpack_public_path__ + "static/media/SCAN_ITEM.10311e9d.svg";